import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { Leaderboard } from 'challenge/module/modules/visualisations/types';

import {
  Wrapper,
  Column,
  SmallStand,
  MediumStand,
  LargeStand,
} from './elements';
import PodiumData from './PodiumData';

type Props = {
  readonly top3: Leaderboard[];
  readonly colors: string[];
};

function Podium({ top3, colors }: Props & ConnectedProps): React.ReactElement {
  return (
    <Wrapper>
      <Column>
        {top3[1] && (
          <>
            <PodiumData leaderboardUnit={top3[1]} size={'medium'} />
            <MediumStand colors={colors}>{2}</MediumStand>
          </>
        )}
      </Column>
      <Column>
        {top3[0] && (
          <>
            <PodiumData leaderboardUnit={top3[0]} size={'large'} />
            <LargeStand colors={colors}>{1}</LargeStand>
          </>
        )}
      </Column>
      <Column>
        {top3[2] && (
          <>
            <PodiumData leaderboardUnit={top3[2]} size={'small'} />
            <SmallStand colors={colors}>{3}</SmallStand>
          </>
        )}
      </Column>
    </Wrapper>
  );
}

export default connect<Props>(Podium);
